(() => {
  const megaMenuSelector = '[data-ws-shop-mega]';

  /*
   * Prevents another category from activating when the cursor only passes
   * over it while travelling toward the subcategory links.
   */
  const hoverIntentDelay = 320;

  function initialiseMegaMenu(menu) {
    if (!menu || menu.dataset.wsInitialised === 'true') return;

    menu.dataset.wsInitialised = 'true';

    const categories = Array.from(
      menu.querySelectorAll('[data-ws-shop-category]')
    );

    const panels = Array.from(
      menu.querySelectorAll('[data-ws-shop-panel]')
    );

    const panelsContainer = menu.querySelector(
      '.ws-shop-mega__panels'
    );

    const defaultCategory =
      menu.dataset.defaultCategory ||
      categories[0]?.dataset.wsShopCategory;

    let activeCategory = defaultCategory;
    let hoverIntentTimer = null;

    function clearHoverIntent() {
      if (!hoverIntentTimer) return;

      window.clearTimeout(hoverIntentTimer);
      hoverIntentTimer = null;
    }

    function activateCategory(categoryKey) {
      if (!categoryKey) return;

      clearHoverIntent();
      activeCategory = categoryKey;

      categories.forEach((category) => {
        const isActive =
          category.dataset.wsShopCategory === categoryKey;

        category.classList.toggle('is-active', isActive);
        category.setAttribute(
          'aria-selected',
          String(isActive)
        );
      });

      panels.forEach((panel) => {
        const isActive =
          panel.dataset.wsShopPanel === categoryKey;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    function scheduleCategoryActivation(categoryKey) {
      clearHoverIntent();

      if (
        !categoryKey ||
        categoryKey === activeCategory
      ) {
        return;
      }

      hoverIntentTimer = window.setTimeout(() => {
        activateCategory(categoryKey);
      }, hoverIntentDelay);
    }

    categories.forEach((category, index) => {
      const categoryKey =
        category.dataset.wsShopCategory;

      category.addEventListener('mouseenter', () => {
        scheduleCategoryActivation(categoryKey);
      });

      /*
       * Cancel the change when the cursor leaves before the intent delay
       * finishes. This stops accidental panel switching.
       */
      category.addEventListener('mouseleave', () => {
        clearHoverIntent();
      });

      /*
       * Keyboard users should not have to wait for the hover delay.
       */
      category.addEventListener('focus', () => {
        activateCategory(categoryKey);
      });

      category.addEventListener('click', () => {
        activateCategory(categoryKey);
      });

      category.addEventListener('keydown', (event) => {
        if (
          event.key !== 'ArrowLeft' &&
          event.key !== 'ArrowRight'
        ) {
          return;
        }

        event.preventDefault();

        const direction =
          event.key === 'ArrowRight' ? 1 : -1;

        const nextIndex =
          (
            index +
            direction +
            categories.length
          ) % categories.length;

        categories[nextIndex]?.focus();
      });
    });

    /*
     * Once the cursor reaches the subcategory area, cancel every pending
     * category switch. The visible links then remain stable and clickable.
     */
    panelsContainer?.addEventListener(
      'mouseenter',
      clearHoverIntent
    );

    panelsContainer?.addEventListener(
      'mousemove',
      clearHoverIntent,
      { passive: true }
    );

    menu.addEventListener(
      'mouseleave',
      clearHoverIntent
    );

    activateCategory(defaultCategory);
  }

  function initialiseAllMegaMenus(root = document) {
    root
      .querySelectorAll(megaMenuSelector)
      .forEach(initialiseMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialiseAllMegaMenus()
    );
  } else {
    initialiseAllMegaMenus();
  }

  /*
   * Reinitialise when Shopify reloads the Header in the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAllMegaMenus(event.target);
    }
  );
})();